/**
 * navigation redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {PUSH_STATE, RESTORE_STATE} from "./consts";


export const pushStateAction = (title, url = "/") => ({
    type: PUSH_STATE,
    title: title,
    url: url
});

export const restoreStateAction = (state) => ({
    type: RESTORE_STATE,
    state: state
});